<template>
    <button
        v-if="desktopSmallDevice ||
            desktopDevice ||
            tabletDevice ||
            hasMobileDevice &&
            !fullList"
        type="button"
        class="a-show-more-btn"
        :class="{'_opened': showMore}"
        @click="$emit('toggleHeight')"
    >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19 1.99963C19.5523 1.99964 20 2.44736 20 2.99964L20 6.38411C20 6.93639 19.5523 7.38411 19 7.38411H15.5C14.9477 7.38411 14.5 6.93639 14.5 6.38411C14.5 5.83182 14.9477 5.38411 15.5 5.38411H16.4995C15.2172 4.51013 13.6685 3.99996 12 3.99996C7.58172 3.99996 4 7.58169 4 12C4 12.5522 3.55228 13 3 13C2.44772 13 2 12.5522 2 12C2 6.47712 6.47715 1.99996 12 1.99996C14.2511 1.99996 16.3291 2.74452 18 3.9994L18 2.99963C18 2.44734 18.4478 1.99963 19 1.99963ZM21 11C21.5523 11 22 11.4477 22 12C22 17.5228 17.5228 22 12 22C9.77403 22 7.71708 21.2719 6.05575 20.0421L6.05573 21C6.05572 21.5523 5.608 22 5.05571 22C4.50343 22 4.05572 21.5522 4.05573 20.9999L4.05579 17.7684C4.05579 17.5031 4.16117 17.2488 4.34873 17.0612C4.53629 16.8737 4.79067 16.7684 5.05591 16.7684L8.30339 16.7688C8.85568 16.7689 9.30334 17.2166 9.30327 17.7689C9.3032 18.3212 8.85543 18.7689 8.30315 18.7688L7.73346 18.7687C8.96845 19.549 10.4312 20 12 20C16.4183 20 20 16.4182 20 12C20 11.4477 20.4477 11 21 11Z" fill="#252628"/>
        </svg>
        <span>
            {{ showMore ? 'Скрыть' : 'Показать ещё' }}
        </span>
    </button>
</template>

<script>
    export default {
        name: 'ShowMoreBtn',
        props: {
            desktopSmallDevice: Boolean,
            desktopDevice: Boolean,
            showMore: Boolean,
            dataList: Object,
            fullList: Boolean,
            hasMobileDevice: Boolean,
            tabletDevice: Boolean,
        }
    } 
</script>
